<template>
  <b-form>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetNane"
          :label-cols="3"
          breakpoint="md"
          label="Name*:"
          label-for="inputName"
        >
          <b-form-input
            id="inputName"
            name="inputName"
            v-validate="'required'"
            type="text"
            v-model="filter.filter_friendly_name"
            data-vv-as="Name"
            placeholder="Filter Name"
            ref="FilterName"
            :disabled="isReadonly"
            maxlength="50"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputName') }}</span>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="fieldsetIsPendingInactive"
          :label-cols="4"
          breakpoint="md"
          label="Disabled:"
          label-for="radio-pending-inactivate"
        >
          <b-form-radio-group
            id="radio-pending-inactivate"
            v-model="filter.is_pending_inactivation"
            name="radio-pending-inactivate"
            :disabled="isReadonly || isPendingInactivationDisabled"
          >
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
            <a href="#" v-if="isPendingInactivationDisabled">
              <i
                class="fa fa-info-circle"
                title="change the end date to a future date to enable filter activation button."
              ></i>
            </a>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" v-if="showPullClaimDateField" >
        <b-form-group
          id="fieldsetPullClaimDate"
          :label-cols="3"
          breakpoint="md"
          label="Pull Claim Date:"
          label-for="inputPullClaimDate"
        >
          <date-picker
            name="inputPullClaimDate"
            v-model="filter.filter_pull_claim_date"
            debounce="500"
            data-vv-as="Pull Claim Date"
            :class="{'input': true, 'text-danger': errors.has('inputPullClaimDate') }"
            class="form-control"
            type="date"
            lang="en"
            format="YYYY-MM-DD"
            confirm
            :disabled="isReadonly"
          ></date-picker>
          <span class="text-danger">{{ errors.first('inputPullClaimDate') }}</span>
        </b-form-group>
      </b-col>
      <b-col :cols="showPullClaimDateField ? '' : '6'">
        <b-form-group
          id="fieldsetActivationDateRange"
          :label-cols="3"
          breakpoint="md"
          label="Active Dates*:"
          label-for="inputActivationDateRange"
        >
          <span>Input 1/1/2099 for no end date</span>
          <date-picker
            name="inputActivationDateRange"
            v-model="activationDateRange"
            debounce="500"
            v-validate="'required'"
            data-vv-as="Active Dates"
            :class="{'input': true, 'text-danger': errors.has('inputActivationDateRange') }"
            class="form-control"
            type="date"
            :not-before="new Date()"
            lang="en"
            range
            format="YYYY-MM-DD"
            range-separator="thru"
            :shortcuts="shortcuts"
            confirm
            :disabled="isReadonly"
          ></date-picker>
          <span class="text-danger">{{ errors.first('inputActivationDateRange') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <VItemList
          v-if="filter && !filter.filter_any_ndc_numbers && filter.filter_ndc_numbers"
          listLabel="NDCs:"
          itemValidation="digits:11"
          itemValidationName="NDC"
          itemPlaceholder="Enter 11 digit NDC"
          :items="filter.filter_ndc_numbers"
          :isReadonly="isReadonly"
          @add="addNDC"
          @remove="removeNDC"
        ></VItemList>
      </b-col>
      <b-col>
        <VItemList
          v-if="showRejectCodeField"
          listLabel="Reject Codes:"
          itemValidation="alpha_num"
          itemValidationName="Reject Code"
          itemPlaceholder="Enter valid reject code"
          :items="filter.filter_rejection_codes"
          :isReadonly="isReadonly"
          @add="addRejectCode"
          @remove="removeRejectCode"
        ></VItemList>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldSetWraparound"
          :label-cols="4"
          breakpoint="md"
          label="Enable Claim Wraparound:"
          label-for="checkBoxWraparound"
        >
          <b-form-checkbox
            id="checkBoxWraparound"
            name="checkBoxWraparound"
            v-model="filter.claim_wraparound_enabled"
            class="customCheck1"
          >
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="showDrugNameField">
      <b-col>
        <b-form-group
          id="fieldsetDrugName"
          :label-cols="4"
          breakpoint="md"
          label="Drug Name:"
          label-for="inputDrugName"
        >
          <b-form-input
            id="inputDrugName"
            name="inputDrugName"
            v-validate="'required'"
            type="text"
            v-model="filter.drug_name"
            data-vv-as="Drug Name"
            placeholder="Drug Name"
            :disabled="isReadonly"
          ></b-form-input>
          <span>Used for OCC claim update process.</span>
          <span class="text-danger">{{ errors.first('inputDrugName') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <VCopayEPARetrySetting :entity="filter" :isReadonly="isReadonly"></VCopayEPARetrySetting>
      </b-col>
    </b-row>
    <b-row v-if="!isReadonly">
      <b-col>
        <span v-if="filter && filter.filter_rules && filter.filter_rules.length > 0">
          <VueQueryBuilder :rules="rules" :styled="true" v-model="queryBuilderFilterRule"></VueQueryBuilder>
          <b-button class="btn btn-info" @click.prevent="showConfirmRemoveRule">Remove Rule</b-button>
        </span>
        <b-button class="btn btn-info" v-else @click.prevent="addRule">Add Rule</b-button>
      </b-col>
    </b-row>
    <b-row v-if="isReadonly">
      <b-col cols="4">
        <p>Rules:</p>
      </b-col>
      <b-col id="filterLongPlainText">
        <span
          v-if="filter && filter.filter_rules && filter.filter_rules.length > 0"
          v-html="$options.filters.ruleToText(filter.filter_rules)"
        ></span>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Vue from "vue";
import VueQueryBuilder from "vue-query-builder";
import VItemList from "@/components/VItemList";
import VCopayEPARetrySetting from "@/components/VCopayEPARetrySetting";
import VTextAreaRuleInput from "@/components/VTextAreaRuleInput";
import RuleMapper from "@/services/utilities/ruleMapper";
import DatePicker from "vue2-datepicker";
import moment from "moment";
// @ts-check
export default {
  name: "VCopayEPAFilterItem",
  components: {
    VueQueryBuilder,
    VItemList,
    VCopayEPARetrySetting,
    VTextAreaRuleInput,
    DatePicker
  },
  props: {
    filter: {
      required: true,
      type: Object
    },
    isReadonly: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      shortcuts: [],
      rules: [
        {
          type: "custom-component",
          component: "VTextAreaRuleInput",
          id: "GroupNumber",
          label: "Group Number",
          operators: ["include", "exclude"]
        },
        {
          type: "custom-component",
          component: "VTextAreaRuleInput",
          id: "PharmacyNCPDPNumber",
          label: "Pharmacy NCPDP Number",
          operators: ["include", "exclude"]
        },
        {
          type: "custom-component",
          component: "VTextAreaRuleInput",
          id: "PharmacyNPI",
          label: "Pharmacy NPI",
          operators: ["include", "exclude"]
        },
        {
          type: "custom-component",
          component: "VTextAreaRuleInput",
          id: "PrescriberNPI",
          label: "Physician NPI",
          operators: ["include", "exclude"]
        },
        {
          type: "custom-component",
          component: "VTextAreaRuleInput",
          id: "PrescriberState",
          label: "State Code",
          operators: ["include", "exclude"]
        }
      ]
    };
  },
  computed: {
    queryBuilderFilterRule: {
      get: function() {
        if (
          this.filter &&
          this.filter.filter_rules &&
          this.filter.filter_rules.length > 0
        ) {
          return RuleMapper.mapToQueryBuilder(this.filter.filter_rules[0]);
        }
        return null;
      },
      set: function(newQuery) {
        this.filter.filter_rules[0] = RuleMapper.mapToRuleRoot(newQuery);
      }
    },
    activationDateRange: {
      get() {
        const startDate = this.filter.filter_start_date || "";
        const endDate = this.filter.filter_end_date || "";
        return [startDate, endDate];
      },
      set(value) {
        Vue.set(this.filter, "filter_start_date", value[0]);
        Vue.set(this.filter, "filter_end_date", value[1]);
      }
    },
    isPendingInactivationDisabled() {
      const now = moment(new Date()).format("YYYYMMDD");
      const endDate = moment(this.filter.filter_end_date).format("YYYYMMDD");
      return endDate < now;
    },
    //  in future we can move the below fields under source settings as UI settings
    showPullClaimDateField() {
      return this.filter && this.filter.source_name !== 'care-central';
    },
    showRejectCodeField() {
      return this.filter && !this.filter.filter_any_rejection_codes && this.filter.filter_rejection_codes;
    },
    showDrugNameField() {
      return this.filter && this.filter.source_name !== 'care-central';
    }
  },
  methods: {
    addRule() {
      Vue.set(this.filter, "filter_rules", [{}]);
    },
    removeRule() {
      this.filter.filter_rules = null;
    },
    addNDC(ndc) {
      this.filter.filter_ndc_numbers.push(ndc);
    },
    removeNDC(index) {
      this.filter.filter_ndc_numbers.splice(index, 1);
    },
    addRejectCode(rejectCode) {
      this.filter.filter_rejection_codes.push(rejectCode);
    },
    showConfirmRemoveRule() {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to remove the rule?", {
          title: "Remove Rule",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value === true) {
            this.removeRule();
          }
        });
    },
    removeRejectCode(index) {
      this.filter.filter_rejection_codes.splice(index, 1);
    }
  }
};
</script>

<style lang="scss">
#filterLongPlainText {
  word-wrap: break-word;
  max-height: 400px;
  overflow: auto;
}
.customCheck1 {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  padding-top: .5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/VCopayEPAFilterItem.vue